import { __read } from "tslib";
import { FontIcon } from '@fluentui/react';
import ActionContextMenuControl from '@office-start/action-context-menu-control';
import ContextMenuControl from '@office-start/context-menu-control';
import { ActionContextMenuItemIcon, } from '@office-start/document-types';
import classNames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
export var ActionsMenuButton = function (props) {
    var buttonRef = useRef(null);
    var targetRef = useRef(null);
    var _a = __read(useState(false), 2), showContextualMenu = _a[0], setShowContextualMenu = _a[1];
    var actions = props.actions, ariaLabel = props.ariaLabel, buttonClasses = props.buttonClasses, iconClasses = props.iconClasses;
    var onShowContextualMenu = useCallback(function (ev) {
        ev.preventDefault(); // don't navigate
        if (ev.currentTarget) {
            var rect = ev.currentTarget.getBoundingClientRect();
            targetRef.current = {
                left: rect.left,
                top: rect.top + rect.height,
            };
        }
        if (!props.contentActionsEnabled && props.onActionMenuToggled) {
            props.onActionMenuToggled(!showContextualMenu);
        }
        setShowContextualMenu(function (previousShowContextualMenu) { return !previousShowContextualMenu; });
    }, [props, showContextualMenu]);
    var onHideContextualMenu = useCallback(function () {
        if (!props.contentActionsEnabled && props.onActionMenuToggled) {
            props.onActionMenuToggled(false);
        }
        setShowContextualMenu(false);
    }, [props]);
    var maybeGetContextMenu = function () {
        if (!showContextualMenu) {
            return null;
        }
        var item = props.item;
        return (React.createElement(ContextMenuControl, { menu: {
                items: actions,
                id: "context-menu-".concat(item.id),
            }, target: targetRef.current || buttonRef, hidden: false, onItemClick: onHideContextualMenu, onDismiss: onHideContextualMenu }));
    };
    // Use v9 toggle for the button
    if (props.contentActionsEnabled) {
        return (React.createElement(ActionContextMenuControl, { items: actions, groupInfo: props.groupInfo, onActionMenuToggled: props.onActionMenuToggled, triggerOptions: {
                ariaLabel: ariaLabel,
                icon: {
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                    iconName: 'MoreIcon',
                },
                tooltip: ariaLabel,
            } }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { "aria-label": ariaLabel, ref: buttonRef, onClick: onShowContextualMenu, className: classNames(buttonClasses) },
            React.createElement(FontIcon, { className: classNames(iconClasses), iconName: "MoreVertical" })),
        maybeGetContextMenu()));
};
//# sourceMappingURL=ActionsMenuButton.js.map